var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEapSquare(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.047,
    height: 12.031,
    viewBox: "0.003 -0.015 12.047 12.031",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 12.028 6 C 12.061 12.571 12.575 11.99 6.028 12 C -0.567 12.01 -0.006 12.572 0.028 6 C 0.062 -0.559 -0.516 -0.01 6.028 0 C 12.572 0.01 11.995 -0.548 12.028 6 Z M 5.602 11.405 C 5.602 11.406 6.509 11.404 6.509 11.404 L 6.517 9.612 L 5.605 9.614 C 5.605 9.614 5.602 11.404 5.602 11.405 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEapSquare);
export default __webpack_public_path__ + "static/media/eap-square.ff7007976a4c918285c591d9d95c0c1b.svg";
export { ForwardRef as ReactComponent };